const DEFAULT_TILES_VERSION = { version: '', scaled: true, hotspotZoomRange: [0, 23] };
function getMetaHost(environment) {
    const resolved = environment ? environment : 'production';
    switch (resolved) {
        case 'testing':
            return 'https://api-maps.tst.c.maps.yandex.ru/services/startup/v1';
        default:
            return 'https://api-maps.yandex.ru/services/startup/v1';
    }
}
/** @module requestMeta */
/**
 * Requests meta data which is necessary for a map construction
 * Please note that your host must be under yandex.ru domain. Referer will be checked.
 *
 * @param {String} lang Language
 * @param {module:requestMeta.RequestMetaOptions} options Request options
 * @returns {Promise<MapMeta>} meta data for map construction
 */
export function requestMeta(lang, options = {}) {
    const { signal, environment } = options;
    const params = new URLSearchParams({ lang });
    const url = `${getMetaHost(environment)}?${params.toString()}`;
    const queryOptions = signal ? { signal } : {};
    return fetch(url, queryOptions)
        .then(response => response.json())
        .then(data => {
        // Fallback to default tiles version
        // If there is a error we can't fallback to default tiles version because we still need router token
        if (!data.layers.map) {
            data.layers.map = { ...DEFAULT_TILES_VERSION };
        }
        return data;
    });
}
